// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gPMLw","content":"styles_content__LVtOx"};